import { LinkComponentType } from "@made-people/grease-link";
import { GreaseRemixLink } from "@made-people/grease-remix";
import { overlayEventEmitter } from "@made-people/blueprint-overlay";

type MissMaryLinkProps = {
  context?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const MissMaryLink: LinkComponentType = (
  props: MissMaryLinkProps & React.ComponentProps<typeof GreaseRemixLink>,
) => {
  if (
    props.context === "menu" ||
    props.context === "mini-cart" ||
    props.context === "cart-item"
  ) {
    // Always close all overlays when clicking on these links
    return (
      <GreaseRemixLink
        {...props}
        onClick={(e) => {
          overlayEventEmitter.emit("close", {});
          props.onClick && props.onClick(e);
        }}
      />
    );
  }

  // All normal links
  return <GreaseRemixLink {...props} />;
};
